<template>
  <kinesis-element
    type="depth"
    tag="svg"
    version="1.1"
    id="Calque_1"
    x="0px"
    y="0px"
    viewBox="0 0 243.4 360"
    style="enable-background:new 0 0 243.4 360;"
    xml:space="preserve"
  >
    <g id="bottom">
      <path
        class="st0"
        d="M205.8,306.6l1.3,53.5h-6.5l-1.2-53.3c-0.9-0.2-1.9-0.8-2.7-1.6c-1.9-1.8-2.5-4.3-1.3-5.5
		c1.2-1.2,3.7-0.8,5.6,1.1c0.7,0.7,1.3,1.5,1.6,2.3c0.3-0.8,0.8-1.6,1.5-2.4c1.8-1.9,4.3-2.5,5.5-1.3c1.2,1.2,0.8,3.7-1.1,5.6
		C207.6,305.7,206.7,306.3,205.8,306.6z"
      />
      <circle class="st1" cx="103.4" cy="297.8" r="4.5" />
      <path
        class="st0"
        d="M111.8,302.7c2.4,4.8,6.9,8.4,11.9,10.1c3.7,1.3,7.6,1.6,11.4,2.5c4.3,1.1,8.5,2.9,11.8,5.9
		c2.3,2,4.1,4.5,6.4,6.6c1.8,1.7,3.9,3,6.2,4c3.5,1.5,7.5,2,11.3,1.3c3.8-0.8,7.3-3,9.4-6.1c1.7-2.4,2.5-5.4,2.9-8.3
		c1.1-7.4-0.4-18.9-7.2-23.5c-2.2-1.5-4.6-1.4-7.2-1.3c-4,0.1-7.7-0.1-11.5-1.5c-5.4-2-10-5.5-15-8.2c-4.9-2.6-10.3-4.4-15.9-4.2
		c-5.5,0.2-11.1,2.8-14.1,7.5C109.5,291.9,109.5,297.9,111.8,302.7z M120.3,291.8c2.4-4.6,10.7-4.9,18.5-0.9
		c7.8,4.1,12.3,11.1,9.9,15.6c-2.4,4.6-10.7,4.9-18.5,0.9C122.3,303.4,117.9,296.4,120.3,291.8z"
      />
      <path
        class="st0"
        d="M105.7,311.5l1.1,48.6h-6.5l-1.1-48.4c-0.9-0.2-1.9-0.8-2.7-1.6c-1.9-1.8-2.5-4.3-1.3-5.5
		c1.2-1.2,3.7-0.8,5.6,1.1c0.7,0.7,1.3,1.5,1.6,2.3c0.3-0.8,0.8-1.6,1.5-2.4c1.8-1.9,4.3-2.5,5.5-1.3c1.2,1.2,0.8,3.7-1.1,5.6
		C107.5,310.6,106.6,311.2,105.7,311.5z"
      />
    </g>
    <kinesis-element tag="g" type="rotate" id="body" axis="x">
      <g>
        <g>
          <g>
            <g>
              <path
                class="st0"
                d="M76.2,174.1l31.3-9.2c0.3,0.5,0.9,1,1.6,1.4c1.6,0.8,3.3,0.7,3.8-0.3c0.5-1-0.3-2.5-1.8-3.4
						c-0.6-0.3-1.2-0.5-1.8-0.5c0.5-0.3,0.9-0.8,1.2-1.4c0.8-1.6,0.7-3.3-0.3-3.8c-1-0.5-2.5,0.3-3.4,1.8c-0.4,0.7-0.5,1.4-0.6,2
						L75,169.9c-0.3-0.5-0.9-1-1.6-1.4c-1.6-0.8-3.3-0.7-3.8,0.3c-0.5,1,0.3,2.5,1.8,3.4c0.6,0.3,1.2,0.5,1.8,0.5
						c-0.5,0.3-0.9,0.8-1.2,1.4c-0.8,1.6-0.7,3.3,0.3,3.8c1,0.5,2.5-0.3,3.4-1.8C76,175.5,76.2,174.7,76.2,174.1z"
              />
              <path
                class="st0"
                d="M70,237l-1.2-53.3c0.6-0.2,1.2-0.6,1.8-1.1c1.2-1.3,1.5-3,0.7-3.8c-0.8-0.8-2.5-0.4-3.7,0.9
						c-0.5,0.5-0.8,1.1-1,1.6c-0.2-0.5-0.6-1.1-1.1-1.5c-1.3-1.2-3-1.5-3.8-0.7c-0.8,0.8-0.4,2.5,0.9,3.7c0.6,0.5,1.2,0.9,1.8,1.1
						l1.2,53.3c-0.6,0.2-1.2,0.6-1.8,1.1c-1.2,1.3-1.5,3-0.7,3.8c0.8,0.8,2.5,0.4,3.7-0.9c0.5-0.5,0.8-1.1,1-1.6
						c0.2,0.5,0.6,1.1,1.1,1.5c1.3,1.2,3,1.5,3.8,0.7c0.8-0.8,0.4-2.5-0.9-3.7C71.3,237.5,70.6,237.1,70,237z"
              />
              <circle class="st1" cx="67.2" cy="174.5" r="3" />
              <circle class="st1" cx="68.3" cy="245.4" r="3" />
            </g>
            <g>
              <g>
                <path
                  class="st1"
                  d="M118.4,148.1l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3h0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C120,146.7,119.4,147.8,118.4,148.1z"
                />

                <rect
                  x="112.3"
                  y="149"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -37.7995 38.7739)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M120.2,154.2l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							h0C121.8,152.8,121.2,153.9,120.2,154.2z"
                />

                <rect
                  x="114.1"
                  y="155.2"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -39.4647 39.538)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M122,160.4l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3v0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3l0,0
							C123.6,159,123,160.1,122,160.4z"
                />
              </g>
              <g>
                <path
                  class="st1"
                  d="M143.9,233l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3v0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3l0,0
							C145.5,231.6,144.9,232.7,143.9,233z"
                />

                <rect
                  x="137.8"
                  y="234"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -60.7858 49.4575)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M145.7,239.2l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							v0C147.3,237.8,146.7,238.9,145.7,239.2z"
                />

                <rect
                  x="139.6"
                  y="240.1"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -62.451 50.2216)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M147.5,245.3l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C149.1,243.9,148.5,245,147.5,245.3z"
                />

                <rect
                  x="141.9"
                  y="246.3"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -64.0959 51.1136)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M149.8,251.5l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C151.4,250.1,150.8,251.2,149.8,251.5z"
                />

                <rect
                  x="143.7"
                  y="252.4"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -65.761 51.8777)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M151.6,257.6l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C153.2,256.2,152.6,257.3,151.6,257.6z"
                />

                <rect
                  x="145.5"
                  y="258.5"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -67.4128 52.637)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M153.4,263.7l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3v0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C155,262.3,154.4,263.4,153.4,263.7z"
                />

                <rect
                  x="147.3"
                  y="264.7"
                  transform="matrix(0.9591 -0.2829 0.2829 0.9591 -69.0779 53.4012)"
                  class="st0"
                  width="6.1"
                  height="2.5"
                />
                <path
                  class="st1"
                  d="M155.2,269.9l-6.6,1.9c-1,0.3-2.1-0.3-2.4-1.3l0,0c-0.3-1,0.3-2.1,1.3-2.4l6.6-1.9c1-0.3,2.1,0.3,2.4,1.3
							l0,0C156.8,268.4,156.2,269.6,155.2,269.9z"
                />
              </g>
              <path
                class="st0"
                d="M137.6,217.8l-15.1-51.1c0.5-0.3,1-0.9,1.4-1.6c0.8-1.6,0.7-3.3-0.3-3.8c-1-0.5-2.5,0.3-3.4,1.8
						c-0.3,0.6-0.5,1.2-0.5,1.8c-0.3-0.5-0.8-0.9-1.4-1.2c-1.6-0.8-3.3-0.7-3.8,0.3c-0.5,1,0.3,2.5,1.8,3.4c0.7,0.4,1.4,0.5,2,0.6
						l15.1,51.1c-0.5,0.3-1,0.9-1.4,1.6c-0.8,1.6-0.7,3.3,0.3,3.8c1,0.5,2.5-0.3,3.4-1.8c0.3-0.6,0.5-1.2,0.5-1.8
						c0.3,0.5,0.8,0.9,1.4,1.2c1.6,0.8,3.3,0.7,3.8-0.3c0.5-1-0.3-2.5-1.8-3.4C139,218,138.3,217.8,137.6,217.8z"
              />
              <circle class="st1" cx="138.1" cy="226.7" r="3" />
            </g>
            <g>
              <path
                class="st1"
                d="M116.2,173.9c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C118.1,171.2,117.6,173,116.2,173.9z"
              />
              <path
                class="st1"
                d="M118.9,183c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C120.8,180.3,120.3,182.1,118.9,183z"
              />
              <path
                class="st1"
                d="M121.6,192.1c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C123.4,189.4,123,191.2,121.6,192.1z"
              />
              <path
                class="st1"
                d="M123.2,202.4c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C125.1,199.7,124.7,201.5,123.2,202.4z"
              />
              <path
                class="st1"
                d="M125.9,211.5c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C127.8,208.8,127.4,210.6,125.9,211.5z"
              />
              <path
                class="st1"
                d="M128.6,220.6c-10.6,6.6-22.7,10.2-35.2,10.4c-1.7,0-3-1.2-3-2.7l0,0c0.1-1.5,1.3-2.7,2.9-2.7
						c11.5-0.2,22.7-3.5,32.4-9.6c1.3-0.8,3-0.5,3.9,0.7l0,0C130.5,217.9,130,219.7,128.6,220.6z"
              />
            </g>
          </g>
          <g>
            <path
              class="st3"
              d="M118.2,159.5c0,0,42.2-15.1,53.8-16.4s51.3,135.8,48.8,149.6s-75.2,26.2-67,9.9
					C161,288.2,124.9,177.5,118.2,159.5z"
            />
            <g>
              <path
                class="st8"
                d="M118.2,159.5c0,0,42.2-15.1,53.8-16.4c2.1-0.2,5.1,4.1,8.6,11.4L121.8,170
						C120.3,165.3,119,161.7,118.2,159.5z"
              />
              <path
                class="st9"
                d="M184.1,162.2L124.5,178c-0.5-1.6-1-3.1-1.5-4.5l59.2-15.6C182.8,159.2,183.4,160.7,184.1,162.2z"
              />
              <path
                class="st10"
                d="M186,166.8L126,182.7c-0.5-1.6-1-3.1-1.5-4.5l59.6-15.7C184.7,163.8,185.4,165.3,186,166.8z"
              />
              <path
                class="st10"
                d="M184.2,162.4l-59.6,15.7c0-0.1,0-0.1-0.1-0.2l59.6-15.7C184.1,162.3,184.1,162.3,184.2,162.4z"
              />
              <path
                class="st11"
                d="M186,166.8c0.3,0.7,0.6,1.4,0.8,2.1l-60.1,15.9c-0.2-0.7-0.5-1.4-0.7-2.1L186,166.8z"
              />
              <path
                class="st12"
                d="M123,173.4c-0.4-1.2-0.8-2.4-1.2-3.5l58.8-15.5c0.5,1.1,1,2.2,1.6,3.4L123,173.4z"
              />
              <path
                class="st13"
                d="M217.6,271.2L154,288c-0.2-1.3-0.4-2.6-0.6-4l63.3-16.7C217.1,268.7,217.4,270,217.6,271.2z"
              />
              <path
                class="st14"
                d="M216.8,267.3l-63.3,16.7c-0.2-1.3-0.4-2.6-0.7-3.9l63-16.7C216.2,264.8,216.5,266.1,216.8,267.3z"
              />
              <path
                class="st9"
                d="M220.7,292.6c-0.1,0.3-0.2,0.7-0.3,1l-60.7,16c-3.2-0.6-5.4-1.7-6.2-3.3l67.3-17.8
						C220.9,290.4,220.9,291.8,220.7,292.6z"
              />
              <path
                class="st10"
                d="M209.5,301.6l-28.6,7.5c-8,1.1-15.6,1.5-20.8,0.6l60.2-15.9C218.9,296.6,214.9,299.3,209.5,301.6z"
              />
              <path
                class="st10"
                d="M220.3,293.9l-60.2,15.9c-0.2,0-0.3-0.1-0.5-0.1l60.7-16C220.4,293.7,220.3,293.8,220.3,293.9z"
              />
              <path
                class="st11"
                d="M180.9,309.2l28.6-7.5C201.7,305,191,307.8,180.9,309.2z"
              />
              <path
                class="st12"
                d="M220.7,288.6l-67.3,17.8c-0.5-1-0.5-2.3,0.3-3.9l0,0l66.5-17.6C220.5,286.3,220.6,287.6,220.7,288.6z"
              />
              <path
                class="st15"
                d="M133.5,206.2c-0.5-1.5-0.9-3-1.4-4.5l60.9-16.1c0.5,1.5,1,3,1.6,4.5L133.5,206.2z"
              />
              <path
                class="st5"
                d="M196.7,196.9c0.5,1.5,1,3.1,1.5,4.7L137,217.8c-0.5-1.6-0.9-3.2-1.4-4.7L196.7,196.9z"
              />
              <path
                class="st16"
                d="M196,194.8l-61.1,16.2c-0.5-1.5-0.9-3-1.4-4.6l61-16.1C195,191.7,195.5,193.3,196,194.8z"
              />
              <path
                class="st16"
                d="M194.5,190.3l-61,16.1c0-0.1,0-0.1-0.1-0.2l61-16.1C194.5,190.1,194.5,190.2,194.5,190.3z"
              />
              <path
                class="st4"
                d="M196.7,196.9l-61.2,16.2c-0.2-0.7-0.4-1.4-0.6-2.1l61.1-16.2C196.3,195.5,196.5,196.2,196.7,196.9z"
              />
              <path
                class="st4"
                d="M196.7,196.9l-61.2,16.2c0,0,0,0,0,0L196.7,196.9C196.7,196.9,196.7,196.9,196.7,196.9z"
              />
              <path
                class="st12"
                d="M192.9,185.6l-60.9,16.1c-0.4-1.2-0.7-2.3-1.1-3.5l60.7-16C192.1,183.2,192.5,184.4,192.9,185.6z"
              />
              <path
                class="st8"
                d="M205.8,226.2L144,242.5c-1.2-4.5-2.5-9-3.7-13.5l61.6-16.3C203.2,217.2,204.5,221.7,205.8,226.2z"
              />
              <path
                class="st13"
                d="M140.2,229c-0.4-1.3-0.7-2.6-1.1-3.8l61.5-16.2c0.4,1.3,0.8,2.5,1.2,3.8L140.2,229z"
              />
              <path
                class="st14"
                d="M200.6,209l-61.5,16.2c-0.4-1.3-0.7-2.6-1.1-3.8l61.4-16.2C199.8,206.4,200.2,207.7,200.6,209z"
              />
              <path
                class="st9"
                d="M208.1,234.2l-62,16.4c-0.4-1.5-0.8-3.1-1.2-4.6l61.9-16.4C207.3,231.2,207.7,232.7,208.1,234.2z"
              />
              <path
                class="st10"
                d="M209.5,239l-62.1,16.4c-0.4-1.5-0.8-3.1-1.2-4.6l62-16.4C208.6,236,209.1,237.5,209.5,239z"
              />
              <path
                class="st10"
                d="M208.2,234.4l-62,16.4c0-0.1,0-0.1,0-0.2l62-16.4C208.2,234.3,208.2,234.4,208.2,234.4z"
              />
              <path
                class="st11"
                d="M209.5,239c0.2,0.7,0.4,1.4,0.6,2.2l-62.2,16.4c-0.2-0.7-0.4-1.5-0.5-2.2L209.5,239z"
              />
              <path
                class="st12"
                d="M206.8,229.7L144.9,246c-0.3-1.2-0.6-2.3-0.9-3.5l61.8-16.3C206.2,227.3,206.5,228.5,206.8,229.7z"
              />
              <path
                class="st15"
                d="M150.4,268.2c-0.3-1.5-0.7-3.1-1.1-4.6l62.3-16.5c0.4,1.6,0.8,3.1,1.2,4.6L150.4,268.2z"
              />
              <path
                class="st5"
                d="M215.8,263.5l-63,16.7c-0.3-1.6-0.6-3.2-0.9-4.8l62.8-16.6C215.1,260.3,215.5,261.9,215.8,263.5z"
              />
              <path
                class="st16"
                d="M214.1,256.5l-62.7,16.6c-0.3-1.5-0.6-3.1-1-4.7l62.5-16.5C213.3,253.5,213.7,255,214.1,256.5z"
              />
              <path
                class="st16"
                d="M212.9,251.9l-62.5,16.5c0-0.1,0-0.1,0-0.2l62.5-16.5C212.9,251.8,212.9,251.8,212.9,251.9z"
              />
              <path
                class="st4"
                d="M214.7,258.7l-62.8,16.6c-0.1-0.7-0.3-1.4-0.4-2.2l62.7-16.6C214.3,257.2,214.5,257.9,214.7,258.7z"
              />
              <path
                class="st4"
                d="M214.7,258.7l-62.8,16.6c0,0,0,0,0,0L214.7,258.7C214.7,258.7,214.7,258.7,214.7,258.7z"
              />
              <path
                class="st12"
                d="M211.7,247.1l-62.3,16.5c-0.3-1.2-0.6-2.4-0.8-3.5l62.2-16.4C211.1,244.8,211.4,245.9,211.7,247.1z"
              />
            </g>
          </g>
        </g>
      </g>
      <kinesis-element tag="g" type="depth" id="head" :strength="15">
        <g>
          <path
            class="st2"
            d="M118.3,17.2c0,0-4.7-23.8-42.7-15.4c-31.2,6.8-28.2,30-28.2,30L118.3,17.2z"
          />
          <path
            class="st3"
            d="M0.7,84.5c6.1,27.6,50.4,33,101.2,21.8s88.7-34.7,82.7-62.3S132.3,3.1,81.6,14.2S-5.4,56.9,0.7,84.5z"
          />
          <g>
            <path
              class="st4"
              d="M0.7,84.5c0.1,0.3,0.1,0.5,0.2,0.8c0,0,0,0,0,0c4.2,0.8,8.3-2,9.1-6.2c0.6-3.3-1-6.5-3.7-8.2
					c3.3,0.9,7-0.6,8.7-3.7c1.8-3.2,1.1-7.1-1.5-9.5c3.1,2,7.2,1.7,10-0.8c2.7-2.4,3.4-6.1,2.2-9.3c3.1,2.5,7.7,2.5,10.7-0.3
					c3.4-3.1,3.7-8.3,0.7-11.8c-1-1.1-2.2-1.9-3.5-2.3c1.3-0.8,2.6-1.6,3.9-2.3c-0.4,2-0.1,4.2,1,6.2c2.5,4.1,7.8,5.5,11.9,3
					c3.5-2.1,5-6.2,3.9-10c2.2,4,7.1,5.9,11.5,4.3c4.9-1.8,7.4-7.2,5.6-12.1c-0.7-1.9-1.9-3.4-3.4-4.5c1.2-0.4,2.5-0.7,3.7-1.1
					c-0.5,1.6-0.7,3.4-0.3,5.2c1.2,5.3,6.4,8.6,11.6,7.4c5.3-1.2,8.6-6.4,7.4-11.6c-0.4-1.9-1.3-3.5-2.6-4.7
					c1.4-0.3,2.8-0.5,4.1-0.7c-1,1.7-1.6,3.7-1.4,5.8c0.4,5.2,5,9.1,10.2,8.6c4.7-0.4,8.3-4.1,8.6-8.6c0.8,3.6,3.8,6.4,7.6,6.8
					c4.5,0.5,8.6-2.6,9.4-7c0,4.5,3.4,8.3,7.9,8.6c3.6,0.3,6.8-1.7,8.3-4.7c0.4,3.6,3.1,6.7,6.9,7.5c3.4,0.7,6.8-0.7,8.7-3.4
					c-0.7,3.3,0.7,6.8,3.8,8.6c3.3,2,7.5,1.3,10-1.4c-2.2,3.1-1.9,7.3,0.8,10.1c3.1,3,8,3,11,0c0.1-0.1,0.2-0.2,0.3-0.3
					c0.1,0.4,0.2,0.8,0.3,1.2l0,0c-6.1-27.6-52.2-40.9-102.9-29.8S-5.4,56.9,0.7,84.5z M177.5,43c0.1-0.4,1.6-4.4,2-4.3
					c0.5,0.1-0.3,4.3-0.4,4.7s-0.6,0.6-1,0.5C177.7,43.8,177.4,43.4,177.5,43z M173.7,41c0.3-0.3,4.3-3.8,4.6-3.4
					c0.3,0.3-3.1,4.3-3.4,4.7c-0.3,0.3-0.9,0.3-1.2,0C173.4,41.9,173.4,41.4,173.7,41z M177.3,36.6c0.1,0.5-3.9,2-4.3,2.1
					c-0.4,0.1-0.8-0.2-0.9-0.7c-0.1-0.5,0.1-0.9,0.5-1C173,36.9,177.2,36.1,177.3,36.6z M166.6,33.2c0-0.4,0.5-4.9,1-4.9
					c0.5,0,0.9,4.5,0.9,4.9c0,0.4-0.4,0.7-0.9,0.7C167,33.9,166.6,33.6,166.6,33.2z M162.3,32.2c0.3-0.4,3.4-4.9,3.8-4.7
					c0.4,0.3-2,5.2-2.3,5.6c-0.3,0.4-0.8,0.6-1.2,0.3C162.2,33.2,162.1,32.6,162.3,32.2z M160.2,28.3c0.4-0.2,4.4-2,4.7-1.6
					c0.2,0.4-3.4,3-3.8,3.2c-0.4,0.2-0.8,0-1.1-0.4C159.7,29,159.8,28.5,160.2,28.3z M153,21.1c0.5-0.2,2.4,4.2,2.5,4.6
					c0.1,0.4-0.2,0.9-0.7,1.1c-0.5,0.2-1,0-1.2-0.4C153.5,25.9,152.5,21.3,153,21.1z M149,26.8c0.1-0.5,1.7-6.1,2.2-6
					c0.5,0.1-0.2,5.9-0.3,6.4c-0.1,0.5-0.6,0.9-1.1,0.8C149.2,27.8,148.9,27.3,149,26.8z M145.5,23.6c0.3-0.3,3.8-3.6,4.2-3.2
					c0.4,0.4-2.4,4.2-2.7,4.5c-0.3,0.3-0.8,0.3-1.2-0.1C145.3,24.5,145.2,24,145.5,23.6z M136.7,18c0.5-0.2,2.9,3.8,3.1,4.2
					c0.2,0.4,0,0.9-0.5,1.1c-0.5,0.2-1,0.1-1.2-0.3S136.2,18.2,136.7,18z M133.6,24.1c0-0.5,0.9-6.2,1.4-6.2c0.5,0,0.5,5.8,0.5,6.3
					c0,0.5-0.5,0.9-1,0.9C133.9,25,133.5,24.6,133.6,24.1z M129.7,21.4c0.2-0.4,3.2-4,3.7-3.7c0.4,0.3-1.9,4.4-2.1,4.8
					c-0.2,0.4-0.8,0.4-1.2,0.1C129.6,22.3,129.5,21.8,129.7,21.4z M119.7,16.4c0.5-0.2,2.8,4,3,4.3s-0.1,0.9-0.6,1.1
					c-0.5,0.2-1,0.1-1.2-0.3C120.7,21.1,119.2,16.6,119.7,16.4z M116.3,22.4c0.1-0.5,1.1-6.3,1.6-6.2c0.5,0.1,0.4,5.9,0.3,6.4
					c-0.1,0.5-0.5,0.9-1.1,0.9C116.6,23.4,116.2,23,116.3,22.4z M112.4,19.7c0.3-0.4,3.4-4,3.8-3.6c0.4,0.3-2,4.4-2.3,4.8
					c-0.3,0.4-0.8,0.4-1.2,0.1C112.3,20.6,112.2,20,112.4,19.7z M101.9,17.1c0.5-0.3,3.8,3.7,4.1,4c0.3,0.4,0.1,1-0.4,1.3
					c-0.5,0.3-1.1,0.3-1.4-0.1C104,22,101.4,17.5,101.9,17.1z M99.5,24.3c0-0.6-0.1-6.9,0.5-7c0.6,0,1.6,6.2,1.6,6.8
					c0,0.6-0.4,1.1-1,1.1C100.1,25.3,99.6,24.9,99.5,24.3z M94.9,22.1c0.2-0.4,2.8-4.9,3.4-4.6c0.5,0.2-1.3,5.1-1.5,5.5
					c-0.2,0.4-0.8,0.6-1.3,0.3C94.9,23.1,94.7,22.5,94.9,22.1z M82.7,19.4c0.4-0.4,4.4,3.2,4.7,3.6s0.2,1-0.2,1.4
					c-0.4,0.4-1.1,0.4-1.4,0.1C85.5,24.1,82.3,19.8,82.7,19.4z M81.4,27c-0.1-0.6-1.1-7.1-0.5-7.2s2.5,6.2,2.6,6.7
					c0.1,0.6-0.2,1.2-0.8,1.3C82.1,28,81.5,27.6,81.4,27z M76.2,25.4c0.1-0.5,2.2-5.4,2.8-5.2c0.6,0.2-0.6,5.4-0.7,5.9
					c-0.1,0.5-0.7,0.7-1.3,0.5C76.4,26.4,76,25.9,76.2,25.4z M67.9,29.4c-0.4-0.3-4-4-3.7-4.4c0.4-0.4,4.6,2.5,5,2.8
					c0.4,0.3,0.4,0.9,0,1.4C68.8,29.5,68.2,29.7,67.9,29.4z M62.5,25.5c0.5-0.2,3.2,5.6,3.4,6.1c0.2,0.5-0.1,1.1-0.6,1.3
					c-0.5,0.2-1.1-0.1-1.3-0.6C63.7,31.9,62,25.7,62.5,25.5z M58.7,31.6c0.1-0.5,1.4-5.5,2-5.4c0.6,0.1,0.2,5.3,0.1,5.7
					s-0.6,0.8-1.2,0.7C59.1,32.5,58.7,32.1,58.7,31.6z M47.4,31.8c0.3-0.5,4.6,1.5,5,1.7c0.4,0.2,0.5,0.8,0.2,1.2
					c-0.3,0.5-0.8,0.7-1.2,0.5C51,34.9,47.1,32.2,47.4,31.8z M46,32.6c0.5-0.3,3.8,4.5,4.1,5c0.3,0.5,0.1,1.1-0.3,1.3
					c-0.5,0.3-1.1,0.1-1.3-0.3C48.1,38.1,45.5,32.9,46,32.6z M43.5,38.7c0-0.4,0.4-5.2,0.9-5.2c0.5,0,1,4.7,1,5.2
					c0,0.4-0.4,0.8-1,0.8C44,39.5,43.5,39.2,43.5,38.7z M32,40c0.2-0.5,4.6,0.5,5,0.7c0.4,0.1,0.6,0.6,0.4,1.1
					c-0.2,0.5-0.6,0.8-1,0.6C36.1,42.3,31.9,40.5,32,40z M30.9,41c0.4-0.3,4.4,3.6,4.8,3.9c0.3,0.4,0.3,1-0.1,1.3
					c-0.4,0.3-1,0.3-1.3-0.1C33.9,45.8,30.5,41.4,30.9,41z M29.7,47.2c-0.1-0.4-0.6-5-0.1-5.1c0.5-0.1,1.8,4.3,1.9,4.7
					s-0.3,0.8-0.8,0.9S29.8,47.6,29.7,47.2z M19.1,49.6c0.2-0.5,4.6,0.5,5,0.7c0.4,0.1,0.6,0.6,0.4,1.1c-0.2,0.5-0.6,0.8-1,0.6
					C23.2,51.9,19,50.1,19.1,49.6z M17.9,50.6c0.4-0.3,4.4,3.6,4.8,3.9c0.3,0.4,0.3,1-0.1,1.3c-0.4,0.3-1,0.3-1.3-0.1
					C21,55.4,17.6,51,17.9,50.6z M16.8,56.8c-0.1-0.4-0.6-5-0.1-5.1c0.5-0.1,1.8,4.3,1.9,4.7c0.1,0.4-0.3,0.8-0.8,0.9
					C17.3,57.5,16.9,57.2,16.8,56.8z M13.6,62.9c-0.4,0-4.7-0.3-4.7-0.8c0-0.5,4.3-0.9,4.6-0.9c0.4,0,0.7,0.4,0.7,0.9
					S14,62.9,13.6,62.9z M8.2,63.4c0.2-0.4,5,1.8,5.4,2c0.4,0.2,0.6,0.8,0.3,1.2c-0.2,0.4-0.8,0.6-1.2,0.3S8,63.8,8.2,63.4z
					 M7.4,64.7c0.4-0.2,2.9,3.2,3.1,3.6c0.2,0.3,0,0.8-0.4,1.1c-0.4,0.2-0.9,0.2-1.1-0.2C8.9,68.9,7,65,7.4,64.7z M7.7,74.4
					c0.2,0.5,0,0.9-0.4,1.1c-0.4,0.1-4.5,1.2-4.7,0.7c-0.2-0.5,3.7-2.2,4.1-2.4C7.1,73.7,7.5,73.9,7.7,74.4z M7.8,79.5
					c-0.5-0.1-5.6-1.4-5.5-1.9c0.1-0.5,5.3,0.1,5.8,0.2c0.5,0.1,0.8,0.5,0.7,1C8.7,79.3,8.3,79.6,7.8,79.5z M2.1,79.2
					c0.3-0.4,3.8,2.1,4.1,2.4c0.3,0.3,0.3,0.8,0,1.1C5.8,83,5.3,83.1,5,82.9C4.7,82.6,1.8,79.5,2.1,79.2z"
            />
            <path
              class="st4"
              d="M1.2,86.4C1.1,86,1,85.6,0.9,85.3C1,85.6,1.1,86,1.2,86.4C1.2,86.4,1.2,86.4,1.2,86.4z"
            />
          </g>
          <path
            class="st5"
            d="M82.7,19.4C33.1,30.3-2.9,59.2,1.2,86.4c-0.2-0.6-0.4-1.2-0.5-1.9c-6.1-27.6,30.1-59.1,80.9-70.2
				s96.8,2.1,102.9,29.8c0.1,0.6,0.2,1.3,0.3,1.9C177.1,19.6,132.3,8.5,82.7,19.4z"
          />
        </g>
        <g>
          <g>
            <path
              class="st0"
              d="M62.6,87c-0.4-26.1,21.6-32.8,29.2-34.4c7.5-1.8,30.3-5.2,41.1,18.6c10.3,22.8,14.5,41.6,0.9,42.6
					c-13.2,1,11.7,24.3-21.2,31.8c-33,7.2-20.3-24.4-32.7-19.8C67.2,130.7,62.9,111.9,62.6,87z"
            />
            <path
              class="st6"
              d="M102.6,101c0,0,10.3,7.7,7.4,11.2c-2.9,3.5-5.9-4.4-5.9-4.4s0.6,8.4-3.5,6.5
					C96.6,112.4,102.6,101,102.6,101z"
            />
            <path
              class="st6"
              d="M82.6,73.6c0,0,5.6-2.2,9.4,7.4s6.5,24.6,3.1,28.2s-18.5,9-23.1-0.3S73.1,74.3,82.6,73.6z"
            />

            <ellipse
              transform="matrix(0.9759 -0.2184 0.2184 0.9759 -25.8574 27.0696)"
              class="st6"
              cx="109.5"
              cy="130.5"
              rx="3.8"
              ry="5.1"
            />
            <g>
              <path
                class="st7"
                d="M106.6,119.1c0,0-4.8-5.3-10.7,0.2c-5.9,5.5-10.3,4.8-11.3,3.4c-1-1.5,0.3-2.1,0.3-2.1s1.8-0.9,2.1,1.4"
              />
              <path
                class="st7"
                d="M107.5,118.8c0,0,1.8-7,9.5-4.8s11.4-0.5,11.5-2.3c0.2-1.7-1.3-1.7-1.3-1.7s-2,0-1.2,2.3"
              />
            </g>
            <path
              class="st6"
              d="M109.1,67.7c0,0-6,0.4-5.4,10.7c0.6,10.3,4.6,25,9.2,26.9c4.6,1.8,20.5,0.2,20.8-10.1S118,64.3,109.1,67.7z
					"
            />
          </g>
        </g>
      </kinesis-element>
      <g id="forearms">
        <kinesis-element
          tag="g"
          type="rotate"
          id="leftarm"
          :strength="20"
          axis="x"
        >
          <path
            class="st0"
            d="M73.5,247.3l41.4-33.6c0.5,0.4,1.2,0.6,2,0.7c1.8,0.2,3.3-0.6,3.4-1.7c0.1-1.1-1.2-2.2-3-2.4
				c-0.7-0.1-1.3,0-1.9,0.2c0.3-0.5,0.5-1.1,0.6-1.8c0.2-1.8-0.6-3.3-1.7-3.4c-1.1-0.1-2.2,1.2-2.4,3c-0.1,0.8,0,1.5,0.3,2.1
				l-41.4,33.6c-0.5-0.4-1.2-0.6-2-0.7c-1.8-0.2-3.3,0.6-3.4,1.7c-0.1,1.1,1.2,2.2,3,2.4c0.7,0.1,1.3,0,1.9-0.2
				c-0.3,0.5-0.5,1.1-0.6,1.8c-0.2,1.8,0.6,3.3,1.7,3.4c1.1,0.1,2.2-1.2,2.4-3C73.9,248.6,73.7,247.9,73.5,247.3z"
          />
          <kinesis-element
            tag="g"
            type="rotate"
            class="lefthand"
            :strength="15"
          >
            <g>
              <rect
                x="117.3"
                y="181.9"
                transform="matrix(-0.7602 -0.6497 0.6497 -0.7602 75.9646 443.1963)"
                class="st4"
                width="5"
                height="51.4"
              />
              <circle class="st4" cx="137.3" cy="187" r="5.3" />
              <path
                class="st5"
                d="M137.3,187.1L137.3,187.1c7.1,6,17.8,5.2,23.8-1.9l11.1-13c6-7.1,5.2-17.8-1.9-23.8l0,0
					c-7.1-6-17.8-5.2-23.8,1.9l-11.1,13C129.4,170.4,130.2,181.1,137.3,187.1z"
              />
              <path
                class="st16"
                d="M138.8,159.3l-0.7,11l11.1-2.5l-0.7,11.3l11.1-2.5l-0.7,10.5c-1,0.8-2.1,1.5-3.3,2.1l0.5-8.7l-11.1,2.5
					l0.7-11.3l-11.1,2.5l0.7-11L138.8,159.3z"
              />
              <path
                class="st15"
                d="M157.1,158.7l-0.7,11.3l11.1-2.5l-0.7,11l-3.4,4l0.7-11L153,174l0.7-11.3l-11.1,2.5l0.7-11l3.2-3.7
					c0.1-0.1,0.1-0.1,0.2-0.2l-0.7,11L157.1,158.7z"
              />
              <path
                class="st8"
                d="M162,144.7c-2.5,3.7-1.9,8.7,1.6,11.6c3.4,2.9,8.5,2.8,11.7-0.2c0.5,1.5,0.8,3,0.8,4.5
					c-4.7,2.9-10.8,2.6-15.2-1.2c-4.4-3.7-5.6-9.8-3.5-14.8C159,144.4,160.5,144.5,162,144.7z"
              />
            </g>
            <g>
              <circle class="st1" cx="117.5" cy="201.7" r="0.9" />
              <path
                class="st0"
                d="M118.8,203.3l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C118.1,202.7,118.3,203.1,118.8,203.3z"
              />
              <path
                class="st0"
                d="M111.9,199.9l3.8,1.8c0.4,0.2,0.8,0,1-0.4l0,0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C111.3,199.3,111.5,199.8,111.9,199.9z"
              />
              <circle class="st1" cx="116.4" cy="204.9" r="0.9" />
              <path
                class="st0"
                d="M117.6,206.5l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C116.9,205.9,117.2,206.3,117.6,206.5z"
              />
              <path
                class="st0"
                d="M110.7,203.1l3.8,1.8c0.4,0.2,0.8,0,1-0.4v0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C110.2,202.5,110.4,203,110.7,203.1z"
              />
              <circle class="st1" cx="114.7" cy="208.4" r="0.9" />
              <path
                class="st0"
                d="M116,210l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C115.3,209.4,115.5,209.8,116,210z"
              />
              <path
                class="st0"
                d="M109.1,206.6l3.8,1.8c0.4,0.2,0.8,0,1-0.4l0,0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C108.5,206,108.7,206.5,109.1,206.6z"
              />
            </g>
          </kinesis-element>
        </kinesis-element>
        <kinesis-element tag="g" type="rotate" id="rightarm" axis="x">
          <path
            class="st0"
            d="M207.2,201.1l15.4-51c0.6,0,1.4-0.2,2-0.5c1.6-0.8,2.4-2.3,1.9-3.4c-0.5-1-2.3-1.2-3.8-0.3
				c-0.6,0.3-1.1,0.7-1.4,1.2c0-0.6-0.2-1.2-0.5-1.8c-0.8-1.6-2.3-2.4-3.4-1.9c-1,0.5-1.2,2.3-0.3,3.8c0.4,0.7,0.9,1.2,1.4,1.6
				l-15.4,51c-0.6,0-1.4,0.2-2,0.5c-1.6,0.8-2.4,2.3-1.9,3.4c0.5,1,2.3,1.2,3.8,0.3c0.6-0.3,1.1-0.7,1.4-1.2c0,0.6,0.2,1.2,0.5,1.8
				c0.8,1.6,2.3,2.4,3.4,1.9c1-0.5,1.2-2.3,0.3-3.8C208.2,202,207.7,201.5,207.2,201.1z"
          />
          <kinesis-element tag="g" type="rotate" class="righthand">
            <g>
              <rect
                x="219.9"
                y="107.6"
                transform="matrix(-0.9978 -6.698748e-02 6.698748e-02 -0.9978 435.3931 281.2093)"
                class="st4"
                width="5"
                height="51.4"
              />
              <circle class="st4" cx="224.2" cy="106.3" r="5.3" />
              <path
                class="st5"
                d="M224.2,106.5L224.2,106.5c9.3,0.6,17.3-6.4,18-15.7l1.1-17.1c0.6-9.3-6.4-17.3-15.7-18h0
					c-9.3-0.6-17.3,6.4-18,15.7l-1.1,17.1C207.9,97.8,215,105.8,224.2,106.5z"
              />
              <path
                class="st16"
                d="M208.9,83.2l6,9.3l7.4-8.6l6.2,9.5l7.4-8.6l5.8,8.9c-0.3,1.3-0.8,2.5-1.4,3.6l-4.8-7.3l-7.4,8.6l-6.2-9.5
					l-7.4,8.6l-6-9.3L208.9,83.2z"
              />
              <path
                class="st15"
                d="M223.1,71.8l6.2,9.5l7.4-8.6l6,9.2l-0.3,5.2l-6-9.2l-7.4,8.6l-6.2-9.5l-7.4,8.6l-6-9.3l0.3-4.9
					c0-0.1,0-0.2,0-0.3l6,9.2L223.1,71.8z"
              />
              <path
                class="st8"
                d="M218.7,57.6c0.2,4.4,3.7,8.1,8.2,8.4c4.5,0.3,8.4-2.8,9.2-7.2c1.3,0.9,2.4,1.9,3.4,3.1
					c-2,5.1-7.1,8.5-12.9,8.2c-5.8-0.4-10.4-4.5-11.7-9.8C216.1,59.3,217.4,58.4,218.7,57.6z"
              />
            </g>
            <g>
              <circle class="st1" cx="222.5" cy="131.7" r="0.9" />
              <path
                class="st0"
                d="M223.7,133.2l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C223.1,132.6,223.3,133.1,223.7,133.2z"
              />
              <path
                class="st0"
                d="M216.9,129.9l3.8,1.8c0.4,0.2,0.8,0,1-0.4l0,0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C216.3,129.2,216.5,129.7,216.9,129.9z"
              />
              <circle class="st1" cx="221.3" cy="134.9" r="0.9" />
              <path
                class="st0"
                d="M222.6,136.4l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C221.9,135.8,222.2,136.3,222.6,136.4z"
              />
              <path
                class="st0"
                d="M215.7,133.1l3.8,1.8c0.4,0.2,0.8,0,1-0.4l0,0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C215.2,132.4,215.3,132.9,215.7,133.1z"
              />
              <circle class="st1" cx="219.7" cy="138.4" r="0.9" />
              <path
                class="st0"
                d="M220.9,139.9l6.1,2c0.4,0.1,0.9-0.1,1-0.5l0,0c0.1-0.4-0.1-0.9-0.5-1l-6.1-2c-0.4-0.1-0.9,0.1-1,0.5l0,0
					C220.3,139.3,220.5,139.8,220.9,139.9z"
              />
              <path
                class="st0"
                d="M214.1,136.6l3.8,1.8c0.4,0.2,0.8,0,1-0.4l0,0c0.2-0.4,0-0.8-0.4-1l-3.8-1.8c-0.4-0.2-0.8,0-1,0.4l0,0
					C213.5,135.9,213.7,136.4,214.1,136.6z"
              />
            </g>
          </kinesis-element>
        </kinesis-element>
      </g>
    </kinesis-element>
  </kinesis-element>
</template>

<script>
import { KinesisElement } from "vue-kinesis";

export default {
  components: {
    KinesisElement
  }
};
</script>

<style lang="scss" scoped>
.st0 {
  fill: #ffce72;
}
.st1 {
  fill: #fff4c5;
}
.st2 {
  fill: #045b5b;
}
.st3 {
  fill: #003234;
}
.st4 {
  fill: #ff7226;
}
.st5 {
  fill: #ffad03;
}
.st6 {
  fill: #221b26;
}
.st7 {
  fill: none;
  stroke: #221b26;
  stroke-width: 0.25;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
}
.st8 {
  fill: #a7b824;
}
.st9 {
  fill: #006188;
}
.st10 {
  fill: #088ab2;
}
.st11 {
  fill: #32b9d8;
}
.st12 {
  fill: #f6e9ab;
}
.st13 {
  fill: #07c17f;
}
.st14 {
  fill: #008166;
}
.st15 {
  fill: #ff4541;
}
.st16 {
  fill: #e90f1d;
}

#body {
  transform-origin: 150px 260px !important;
}

#head {
  transform-origin: 110px 130px !important;
}

#rightarm {
  transform-origin: 190px 210px !important;
}

.righthand {
  transform-origin: 220px 140px !important;
}
#leftarm {
  transform-origin: 70px 250px !important;
}
.lefthand {
  transform-origin: 125px 216px !important;
}

svg {
  overflow: visible;
}
</style>
